// extracted by mini-css-extract-plugin
export var hidden = "_u1-0";